import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { DateProvider } from '../_models/DateProvider';
import { Observable } from 'rxjs';
import { IAppConfig } from '../lib/config/app-config';
import { APP_CONFIG } from '../lib/angular/injection-tokens';

@Injectable({
  providedIn: 'root',
})
export class DateProviderService {
  private baseUrl: string = this.config.publicBaseUrl;
  private static readonly path: string = 'DateProvider/';
  dateProvider: DateProvider;

  constructor(private http: HttpClient, @Inject(APP_CONFIG) private config: IAppConfig) { }

  public getDateProvider$(): Observable<DateProvider> {
    return this.http.get<DateProvider>(this.baseUrl + DateProviderService.path);
  }
}
